import React, { useEffect, useState } from "react";
import AddQuestion from "./AddQuestion";
import { useSelector } from "react-redux";
import { UploadQuestionnaireList } from "../../../api/helper";
import AddNewQuestionnaire from "./AddNewQuestionnaire";
import { ShowToast } from "../../../helpers/ToastService";

function AddCategoryAndQuestions({
  CloseModal,
  GetFetchcategoriescreate,
  editValue,
}) {
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [AddCategory, setAddCategory] = useState("AddCategory");
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    id: "",
    label: "",
    description: "",
    name: "",
    abbreviation: "",
    agencyId: profiledata._id,
  });
  const [ranges, setRanges] = useState([
    {
      id: 1,
      rangeStart: "",
      rangeEnd: "",
      interpretation: "",
      color: "",
    },
  ]);

  useEffect(() => {
    if (editValue && Object.keys(editValue).length > 0) {
      setForm({
        id: editValue._id,
        label: editValue.label || editValue.name,
        name: editValue.name || "",
        abbreviation: editValue.abbreviation || "",
        description: editValue.scoringRange?.description || "",
        agencyId: profiledata._id,
      });

      setRanges(
        editValue.scoringRange?.ranges || [
          {
            id: 1,
            rangeStart: "",
            rangeEnd: "",
            interpretation: "",
            color: "",
          },
        ]
      );
    }
  }, [editValue]);

  const handleTabClick = (tab) => {
    setAddCategory(tab);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      ...form,
      ranges: JSON.stringify(ranges),
    };
    setLoading(true);
    try {
      const response = await UploadQuestionnaireList(data);
      if (response) {
        ShowToast("Category added successfully", "success");
        GetFetchcategoriescreate();
        CloseModal();
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      ShowToast(
        error?.response?.data?.message ||
          "Something went wrong ! Please check console"
      );
      setLoading(false);
    }
  };

  return (
    <>
      <div className="questionnaire-container">
        <div
          style={{
            fontSize: "20px",
            cursor: "pointer",
            width: 50,
            position: "absolute",
            right: 18,
            top: 27,
          }}
        >
          <span className="close" onClick={CloseModal}>
            &times;
          </span>
        </div>

        <div style={{ display: "flex", marginBottom: 20, width: "100%" }}>
          <div
            className={
              AddCategory === "AddCategory"
                ? "General_Settings"
                : "Clinical_Settings"
            }
            onClick={() => handleTabClick("AddCategory")}
          >
            {editValue && Object.keys(editValue).length > 0
              ? "Update Category"
              : "Add Category"}
          </div>
          <div
            className={
              AddCategory === "AddQuestion"
                ? "General_Settings"
                : "Clinical_Settings"
            }
            style={{
              pointerEvents: editValue ? "none" : "auto",
              opacity: editValue ? 0.5 : 1,
            }}
            onClick={() => {
              if (!editValue) handleTabClick("AddQuestion");
            }}
          >
            Add Question
          </div>
        </div>

        {AddCategory === "AddCategory" && (
          <div className="forscrolll">
            <h1 className="add-question-title">
              {editValue?._id ? "Update Category" : "Add New Category"}
            </h1>

            <form onSubmit={handleSubmit} className="add-question-form">
              <div className="add-form-group">
                <label className="add-form-label">Category Name</label>
                <input
                  type="text"
                  name="categoryTitle"
                  className="add-form-input"
                  value={form?.name}
                  // placeholder="Category name"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      name: e.target.value,
                      label: e.target.value,
                    })
                  }
                />
              </div>

              <div className="add-form-group">
                <label className="add-form-label">Category Abbreviation</label>
                <input
                  type="text"
                  name="categoryTitle"
                  className="add-form-input"
                  placeholder="PHQ, GAD, AUDIT, DAST, CSSRS, PTSD, SLEEP, MDQ, FMMSE, PRIME"
                  value={form?.abbreviation}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      abbreviation: e.target.value,
                      id: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <label
                  htmlFor="description"
                  className="block text-sm font-medium mb-2"
                >
                  Description
                </label>
                <textarea
                  type="text"
                  required
                  name="description"
                  className="w-full p-2 border rounded"
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                ></textarea>
              </div>
              <AddNewQuestionnaire
                setForm={setForm}
                form={form}
                ranges={ranges}
                setRanges={setRanges}
              />
              <button
                type="submit"
                disabled={loading}
                className="add-submit-btn"
              >
                {loading
                  ? editValue?._id
                    ? "Updating..."
                    : "Creating..."
                  : editValue?._id
                  ? "Update Category"
                  : "Add Category"}
              </button>
            </form>
          </div>
        )}

        {AddCategory === "AddQuestion" && (
          <AddQuestion
            CloseModal={CloseModal}
            GetFetchcategoriescreate={GetFetchcategoriescreate}
          />
        )}
      </div>
    </>
  );
}

export default AddCategoryAndQuestions;
